<template>
  <div>
    <div class="web">
      <div class="top-bg">
        <div class="top-title">定制补剂一站式解决方案</div>
        <div class="top-title-en">Custom Supplement One-Stop Solution</div>
        <div class="top-point-wrap">
          <div
            v-for="(item, i) in topPointList"
            :key="i"
            class="top-point-item"
          >
            <img :src="item.bg" alt="" />
            <div class="point-info">
              <img :src="item.icon" alt="" />
              <div>{{ item.title }}</div>
              <span>{{ item.description }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="scene-module">
        <div class="scene-left">
          <div class="scene-title">助你突破<br />更多业务场景</div>
          <div class="scene-description">打造更好个性化定制体验</div>
          <div class="scene-items">
            <div class="scene-item" v-for="(item, i) in sceneList" :key="i">
              <div>{{ item }}</div>
              <img :src="`${httpImg}/red-check.png`" alt="" />
            </div>
          </div>
        </div>
        <!-- <img class="scene-right" :src="`${httpImg}/scene-banner.png`"> -->
        <img
          class="scene-right"
          src="https://cdn-file.xiaojudai.cn/web/dist/plan/plan_pic2_1920.png"
        />
      </div>
      <div class="strength-module">
        <el-carousel
          indicator-position="none"
          :autoplay="false"
          arrow="always"
          height="17.12rem"
        >
          <el-carousel-item v-for="(item, i) in solutionSwiperList" :key="i">
            <div class="content">
              <div class="swiper-left">
                <div class="swiper-title">营养科技 卓越实力</div>
                <div class="swiper-left-content">
                  <div class="content-title">
                    <div class="content-title-text">{{ item.title }}</div>
                    <div class="content-title-num">0{{ i + 1 }}</div>
                  </div>
                  <div
                    class="content-description"
                    v-html="item.description"
                  ></div>
                  <div class="content-tips" v-if="item.tipList">
                    <div
                      class="content-tips-item"
                      v-for="(tipItem, j) in item.tipList"
                      :key="j"
                    >
                      <img :src="`${httpImg}/gray-check.png`" alt="" />
                      <div>{{ tipItem }}</div>
                    </div>
                  </div>
                </div>
                <div class="content-images">
                  <img
                    v-for="(imageItem, k) in item.imageList"
                    :key="k"
                    :src="imageItem"
                    alt=""
                  />
                </div>
              </div>
              <img class="swiper-right" :src="item.banner" alt="" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="partner-module">
        <div class="partner-title">Business Partner</div>
        <div class="partner-title-ch">合作伙伴</div>
        <!-- <img class="company-image" :src="`${httpImg}/company.png`" alt=""> -->
        <img
          class="company-image"
          src="https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/company.png"
          alt=""
        />

        <div class="contact-wrap">
          <div class="contact-us">
            <div>联系我们</div>
            <div>028-8521-1401</div>
          </div>
          <div class="contact-line"></div>
          <div class="contact-tips">致电了解更多定制产品线解决方案</div>
        </div>
      </div>
    </div>
    <div class="mobile">
      <div class="top-bg">
        <div class="top-title">定制补剂<br />一站式解决方案</div>
        <div class="top-title top-title_768">定制补剂一站式解决方案</div>
        <div class="top-title-en">Custom Supplement One-Stop Solution</div>
      </div>
      <div class="scene-module">
        <div class="point-wrap">
          <div class="point-item" v-for="(item, i) in topPointList" :key="i">
            <img class="point-item-bg" :src="item.h5Bg" alt="" />
            <div class="point-item-right">
              <img class="point-info-icon" :src="item.icon" alt="" />
              <div class="point-info">
                <div>{{ item.title }}</div>
                <span>{{ item.description }}</span>
              </div>
            </div>
          </div>
          <div
            class="point-item point-item_768"
            v-for="(item, i) in topPointList"
            :key="i"
          >
            <img class="point-item-bg" :src="item.bg_768" alt="" />
            <div class="point-item-right">
              <img class="point-info-icon" :src="item.icon" alt="" />
              <div class="point-info">
                <div>{{ item.title }}</div>
                <span>{{ item.description }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="scene-title">助你突破 更多业务场景</div>
        <div class="scene-description">打造更好个性化定制体验</div>
        <!-- <img class="scene-banner" :src="`${httpImg}/scene-banner.png`"> -->
        <img
          class="scene-banner"
          src="https://cdn-file.xiaojudai.cn/web/dist/plan/plan_pic2_1920.png"
        />
        <!-- <div class="scene-banner" style="background-image: url('https://cdn-file.xiaojudai.cn/web/dist/plan/plan_pic2_1920.png');"></div> -->
        <div class="scene-items">
          <div class="scene-item" v-for="(item, i) in sceneList" :key="i">
            <div>{{ item }}</div>
            <img :src="`${httpImg}/red-check.png`" alt="" />
          </div>
        </div>
      </div>
      <div class="strength-module">
        <div class="strength-title">营养科技 卓越实力</div>
        <div class="swiper-wrap">
          <div class="swiper-items">
            <div v-for="(item, i) in solutionSwiperList" :key="i">
              <img class="swiper-item" :src="item.banner" />
              <div class="swiper-left-content">
                <div class="content-title">
                  <div class="content-title-text">{{ item.title }}</div>
                  <div class="content-title-num">0{{ i + 1 }}</div>
                </div>
                <div
                  class="content-description"
                  v-html="item.description"
                ></div>
                <div class="content-tips" v-if="item.tipList">
                  <div
                    class="content-tips-item"
                    v-for="(tipItem, j) in item.tipList"
                    :key="j"
                  >
                    <img :src="`${httpImg}/gray-check.png`" alt="" />
                    <div>{{ tipItem }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 768平板特殊处理 -->
        <div class="swiper-wrap_768">
          <el-carousel
            style="z-index: 1"
            height="21.3rem"
            :autoplay="false"
            arrow="never"
            ref="my_swiper"
          >
            <el-carousel-item
              v-for="(item, i) in solutionSwiperList"
              :key="i"
              :name="i + ''"
              class="swiper_item_768"
            >
              <img :src="item.banner" class="swiper_img" />

              <div class="swiper_des">
                <div class="swiper-left-content swiper-left-content_768">
                  <div class="content-title">
                    <div class="content-title-text">{{ item.title }}</div>
                    <div class="content-title-num">0{{ i + 1 }}</div>
                  </div>
                  <div
                    class="content-description content-description_768"
                    v-html="item.description"
                  ></div>
                  <div class="content-tips" v-if="item.tipList">
                    <div
                      class="content-tips-item"
                      v-for="(tipItem, j) in item.tipList"
                      :key="j"
                    >
                      <img :src="`${httpImg}/gray-check.png`" alt="" />
                      <div>{{ tipItem }}</div>
                    </div>
                  </div>
                  <!-- <div class="content-tips" >
                    <div
                      class="content-tips-item"
                      v-for="i in 2"
                      :key="i"
                    >
                      <img :src="`${httpImg}/gray-check.png`" alt="" />
                      <div>获美国NSF cGMP 455-2 膳食补充剂良好生产规范认证</div>
                    </div>
                  </div> -->
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>

          <div class="swiper_pos">
            <img
              v-for="(item2, i2) in solutionSwiperList"
              @click.stop="changeSwiper(i2)"
              :key="i2"
              :src="item2.banner"
              :class="[
                'min_img',
                i2 == currrentSwiperIndex ? 'min_img_act' : '',
              ]"
            />
          </div>
        </div>
      </div>
      <div class="partner-module">
        <div class="partner-title">Business Partner</div>
        <div class="partner-title-ch">合作伙伴</div>
        <img class="company-image" :src="`${httpImg}/company-h5.png`" alt="" />
        <div class="contact-wrap">
          <div>联系我们</div>
          <div></div>
          <div>028-8521-1401</div>
          <div class="contact-tips">致电了解更多定制产品线解决方案</div>
        </div>

        <div class="contact-wrap_768">
          <div class="topInfo">
            <div class="bigTxt">联系我们</div>
            <div class="contact_number">028-8521-1401</div>
          </div>
          <div class="contact-tips_768">致电了解更多定制产品线解决方案</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "fulfillment",
  components: {},
  data: () => ({
    currrentSwiperIndex: 0,
    data1: "",
    publicurl: "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/",
    httpImg:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution",
    topPointList: [
      {
        bg: "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/top-point-bg-1.png",
        bg_768:
          "https://cdn-file.xiaojudai.cn/web/dist/fangan/top-point-bg-1_768.png",
        icon: "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/top-point-icon-1.png",
        title: "一体化解决方案",
        description: "从评估系统到仓装配解决方案",
        h5Bg: "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/h5-point-bg-1.png",
      },
      {
        bg: "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/top-point-bg-2.png",
        icon: "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/top-point-icon-2.png",
        bg_768:
          "https://cdn-file.xiaojudai.cn/web/dist/fangan/top-point-bg-2_768.png",
        title: "第一条定制线",
        description: "国内第一条定制补剂全自动分装线",
        h5Bg: "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/h5-point-bg-2.png",
      },
      {
        bg: "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/top-point-bg-3.png",
        bg_768:
          "https://cdn-file.xiaojudai.cn/web/dist/fangan/top-point-bg-3_768.png",
        icon: "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/top-point-icon-3.png",
        h5Bg: "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/h5-point-bg-3.png",
        title: "标准化认证",
        description: "分装环境通过FDA注册和ISO认证",
      },
    ],

    sceneList: [
      "定制每日补剂",
      "定制日装袋",
      "非补剂内容物",
      "外包装盒",
      "物流箱",
    ],
    solutionSwiperList: [
      {
        banner:
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-1.png",
        title: "全球专家团队",
        description:
          "NHRC营养科学与食品安全团队帮助您选择更优的成分和剂量，制定出更优质有效的配方",
        imageList: [
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-2.png",
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-3.png",
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-4.png",
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-5.png",
        ],
      },
      {
        banner:
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-2.png",
        title: "供应链资源",
        description:
          "我们向你开放美国及全球供应链联盟资源，提供更适合你的优质生产制造方案。",
        imageList: [
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-3.png",
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-4.png",
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-5.png",
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-1.png",
        ],
      },
      {
        banner:
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-3.png",
        title: "全链追溯",
        description:
          "对于服食产品安全性问题，我们和你一样关注<br>产品追溯精确到最小容器<br>从生产到用户手中，全链数据追溯可查",
        imageList: [
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-4.png",
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-5.png",
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-1.png",
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-2.png",
        ],
      },
      {
        banner:
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-4.png",
        title: "全自动分装",
        description:
          "根据订单数据进行个性化的全自动分装定制，一切都在高标准*洁净间内完成。洁净分装中心执行FDA、NSF GMP、ISO 标准化洁净管理",
        tipList: [
          "获美国NSF cGMP 455-2 膳食补充剂良好生产规范认证",
          "获ISO 9001、ISO 22000食品安全及质量管控等多项国际体系认证",
        ],
        imageList: [
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-5.png",
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-1.png",
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-2.png",
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-3.png",
        ],
      },
      {
        banner:
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-5.png",
        title: "AI营养评估系统",
        description:
          "DigiHealth™在线AI营养评估引擎<br>可以根据您的特定业务需求进行二次开发",
        imageList: [
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-1.png",
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-2.png",
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-3.png",
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-item-4.png",
        ],
      },
    ],
  }),
  mounted() {},
  methods: {
    changeSwiper(index) {
      this.currrentSwiperIndex = index;
      this.$refs.my_swiper.setActiveItem(index + "");
      console.log("changeSwiper----------", index);
    },
  },
};
</script>

<style scoped lang="scss">
/* 统一鼠标样式 */
.cursor {
  cursor: pointer;
}
//mobile414
@media screen and (max-width: 767px) {
  .web {
    display: none;
  }

  .mobile {
    margin: 1.38rem 0 0 0;
    overflow-x: hidden;
  }

  .top-bg {
    position: relative;
    /* width: 10rem; */
    width: 100%;
    height: 7.56rem;
    background-image: url("https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-top-bg-h5.png");
    background-size: cover;
    background-position: center;
    padding: 2.2rem 0 0 0;
    box-sizing: border-box;
  }

  .top-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.72rem;
    color: #ffffff;
    line-height: 1.01rem;
  }
  .top-title_768 {
    display: none;
  }

  .top-title-en {
    font-family: MADEEvolveSans;
    font-size: 0.31rem;
    color: #ffffff;
    line-height: 0.36rem;
    margin: 0.17rem 0 0 0;
  }

  .scene-module {
    position: relative;
    padding: 7.9rem 0 0.92rem 0;
    background-color: white;

  }

  .point-wrap {
    position: absolute;
    width: 100%;
    top: -0.97rem;
    left: 0;
  }

  .point-item {
    position: relative;
    width: 8.84rem;
    height: 2.15rem;
    margin: 0 auto 0.27rem auto;
  }
  .point-item_768 {
    display: none;
  }
  .point-item-bg {
    width: 100%;
    height: 100%;
  }

  .point-item-right {
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0 0 0 0.77rem;
  }

  .point-info-icon {
    width: 0.77rem;
    height: auto;
  }

  .point-info {
    text-align: left;
    margin: 0 0 0 0.65rem;
    padding: 0.02rem 0;
  }

  .point-info div {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.34rem;
    color: #ffffff;
    line-height: 0.48rem;
  }

  .point-info span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.29rem;
    color: #ffffff;
    line-height: 0.68rem;
  }

  .scene-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.72rem;
    color: #1a1a1a;
    line-height: 1.01rem;
  }

  .scene-description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.31rem;
    color: #333333;
    line-height: 0.43rem;
    margin: 0.29rem 0 0 0;
  }

  .scene-banner {
    width: 126%;
    height: auto;
    margin: 0.29rem auto 0;
    border-radius: 0.2rem;
    margin-left: -0.85rem;

    /* width: 100%;
			height: 10.19rem;
			background-size: cover;
			background-position:-0.77rem 0; */
  }

  .scene-items {
    /* margin: 1.01rem 0 0 0; */
    /* margin:-0.4831rem 0 0 0; */
    margin: -0.4831rem 0 0 0;
    padding: 0 0.58rem;
    background-color: white;
  }

  .scene-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0.02rem solid #bbbbbb;
    padding: 0 0 0.27rem 0;
    margin: 0 0 0.45rem 0;
  }

  .scene-item div {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.34rem;
    color: #1a1a1a;
    line-height: 0.73rem;
  }

  .scene-item img {
    width: 0.48rem;
    height: auto;
  }

  .strength-module {
    padding: 1.88rem 0 1.45rem 0;
    background: #f6f4f1;
  }

  .strength-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.72rem;
    color: #1a1a1a;
    line-height: 1.01rem;
  }

  .swiper-wrap {
    position: relative;
    overflow-x: auto;
    margin: 1.01rem 0 0 0;
    padding: 0 0.58rem;
    /* 隐藏 WebKit 浏览器的滚动条 */
    -webkit-overflow-scrolling: touch;
    /* 隐藏滚动条 */
    scrollbar-width: none;
  }
  .swiper-wrap_768{
	display: none;
  }

  .swiper-wrap::-webkit-scrollbar {
    display: none;
  }

  .swiper-items {
    display: grid;
    grid-template-columns: repeat(5, 7.73rem);
    gap: 0.53rem;
    transition: transform 0.3s ease;
  }

  .swiper-item {
    width: 7.73rem;
    height: 7.73rem;
    border-radius: 0.19rem;
  }

  .swiper-left-content {
    height: 5.29rem;
    width: 7.75rem;
    border-top: 0.02rem solid #000000;
    border-bottom: 0.02rem solid #000000;
    margin: 0.8rem 0 0 0;
    padding: 0.77rem 0 0 0;
    box-sizing: border-box;
  }

  .content-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .content-title-text {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.48rem;
    color: #141414;
    line-height: 0.58rem;
  }

  .content-title-num {
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 0.77rem;
    color: #141414;
    line-height: 0.77rem;
  }

  .content-description {
    width: 7.73rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.29rem;
    color: #141414;
    line-height: 0.58rem;
    margin: 0.39rem 0 0 0;
    text-align: left;
  }

  .content-tips {
    margin: 0.22rem 0 0 0;
  }

  .content-tips-item {
    display: flex;
    align-items: center;
    margin: 0 0 0.08rem 0;
  }

  .content-tips-item img {
    width: 0.29rem;
    height: auto;
  }

  .content-tips-item div {
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 0.24rem;
    color: #666666;
    line-height: 0.43rem;
    margin: 0 0 0 0.1rem;
  }

  .partner-module {
    padding: 1.45rem 0 0 0;
    background-color: white;
  }

  .partner-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.72rem;
    color: #141414;
    line-height: 0.85rem;
  }

  .partner-title-ch {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.31rem;
    color: #000000;
    line-height: 0.43rem;
    margin: 0.29rem 0 0 0;
  }

  .company-image {
    width: 7.81rem;
    height: auto;
    margin: 1.04rem 0 0 0;
  }

  .contact-wrap {
    padding: 1.45rem 0.58rem;
    background: #c25e4d;
    margin: 1.93rem 0 1.5rem 0;
  }
  .contact-wrap_768{
	display: none;
  }

  .contact-wrap div:nth-child(1) {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.72rem;
    color: #ffffff;
    line-height: 1.01rem;
  }
  .contact-wrap div:nth-child(2) {
    height: 0.02rem;
    background: #ffffff;
    margin: 0.58rem 0 0 0;
  }
  .contact-wrap div:nth-child(3) {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.72rem;
    color: #ffffff;
    line-height: 1.01rem;
    margin: 0.58rem 0 0 0;
  }
  .contact-wrap div:nth-child(4) {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.29rem;
    color: #ffffff;
    line-height: 0.29rem;
    margin: 0.22rem 0 0 0;
  }
}
//pad768
@media screen and (min-width: 768px) and (max-width: 1439px) {
  .web {
    display: none;
  }

  .mobile {
    margin: 1.64rem 0 0 0;
    overflow-x: hidden;
  }

  .top-bg {
    position: relative;
    /* width: 10rem; */
    width: 100%;
    height: 8.7rem;
    background-image: url("https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-top-bg-h5.png");
    background-size: cover;
    background-position: center;
    padding: 3.32rem 0 0 0;
    box-sizing: border-box;
  }

  .top-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.96rem;
    color: #ffffff;
    line-height: 1.35rem;
    display: none;
  }
  .top-title_768 {
    display: block;
  }

  .top-title-en {
    font-family: MADEEvolveSans;
    font-size: 0.41rem;
    color: #ffffff;
    line-height: 0.48rem;

    margin: 0.17rem 0 0 0;
  }

  .scene-module {
    position: relative;
    padding: 9.4rem 0 0rem 0;
  }

  .point-wrap {
    position: absolute;
    width: 100%;
    top: -1.34rem;
    left: 0;
  }

  .point-item {
    position: relative;
    width: calc(100% - 1.62rem);
    height: 2.68rem;
    margin: 0 auto 0.44rem auto;
    display: none;
  }
  .point-item_768 {
    display: block;
  }

  .point-item-bg {
    width: 100%;
    height: 100%;
  }

  .point-item-right {
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0 0 0 1.2rem;
  }

  .point-info-icon {
    width: 1.12rem;
    height: auto;
  }

  .point-info {
    text-align: left;
    margin: 0 0 0 1.02rem;
    // padding: 0.02rem 0;
  }

  .point-info div {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.41rem;
    color: #ffffff;
    line-height: 0.56rem;
    margin-bottom: 0.12rem;
  }

  .point-info span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.3rem;
    color: #ffffff;
    line-height: 0.52rem;
  }

  .scene-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.81rem;
    color: #1a1a1a;
    line-height: 1.15rem;
  }

  .scene-description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.41rem;
    color: #333333;
    line-height: 0.56rem;
    margin: 0.37rem 0 0 0;
  }

  .scene-banner {
    width: 100%;
    height: auto;
    margin: 0.56rem auto 0;
    border-radius: 0rem;
    margin-left: -0rem;

    /* width: 100%;
			height: 10.19rem;
			background-size: cover;
			background-position:-0.77rem 0; */
  }

  .scene-items {
    /* margin: 1.01rem 0 0 0; */
    /* margin:-0.4831rem 0 0 0; */
    margin: -0rem 0 0 0;
    padding: 0 0.82rem;

    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 1.84rem;
  }

  .scene-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0.02rem solid #bbbbbb;
    padding: 0 0 0rem 0;
    margin: 0 0 0.14rem 0;
    width: calc((100% - 0rem - 0.86rem) / 2);
  }

  .scene-item div {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.34rem;
    color: #333333;
    line-height: 1.35rem;
  }

  .scene-item img {
    width: 0.44rem;
    height: auto;
  }

  .strength-module {
    padding: 1.88rem 0 1.85rem 0;
    background: #f6f4f1;
  }

  .strength-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.81rem;
    color: #141414;
    line-height: 1.15rem;
  }

  .swiper-wrap {
    display: none;
    position: relative;
    overflow-x: auto;
    margin: 1.01rem 0 0 0;
    padding: 0 0.58rem;
    /* 隐藏 WebKit 浏览器的滚动条 */
    -webkit-overflow-scrolling: touch;
    /* 隐藏滚动条 */
    scrollbar-width: none;
  }

  .swiper-wrap::-webkit-scrollbar {
    display: none;
  }

  .swiper-items {
    display: grid;
    grid-template-columns: repeat(5, 7.73rem);
    gap: 0.53rem;
    transition: transform 0.3s ease;
  }

  .swiper-item {
    width: 7.73rem;
    height: 7.73rem;
    border-radius: 0.19rem;
  }

  .swiper-left-content {
    height: 4.4rem;
    // width: 7.75rem;
    border-top: 0.02rem solid #000000;
    border-bottom: 0.02rem solid #000000;
    margin: 0rem 0 0 0;
    padding: 0.6rem 0 0rem 0;
    // box-sizing: border-box;
  }

  .content-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .content-title-text {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.41rem;
    color: #141414;
    line-height: 0.44rem;
  }

  .content-title-num {
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 0.81rem;
    color: #141414;
    line-height: 1rem;
  }

  .content-description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.26rem;
    color: #141414;
    line-height: 0.52rem;
    text-align: left;
    margin: 0rem 0 0 0;
  }

  .content-tips {
    margin: 0.33rem 0 0 0;
  }

  .content-tips-item {
    display: flex;
    align-items: center;
    margin: 0 0 0.08rem 0;
  }

  .content-tips-item img {
    width: 0.28rem;
    height: auto;
  }

  .content-tips-item div {
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 0.22rem;
    color: #666666;
    line-height: 0.39rem;
    margin: 0 0 0 0.12rem;
  }
  .swiper-wrap_768 {
    padding: 0 0.82rem;
    margin-top: 1.48rem;
    position: relative;
  }
  .swiper_item_768 {
  }
  .swiper-left-content_768 {
    width: 100%;
    margin-top: 4.12rem;
  }
  .content-description_768 {
    width: 9.85rem;
  }
  .swiper_img {
    width: 100%;
    height: 12.6rem;
  }
  .swiper_pos {
    padding-left: 2px;
    height: 4.12rem;
    // background: pink;
    display: flex;
    align-items: center;

    position: absolute;
    left: 0.82rem;
    top: 12.5rem;
    z-index: 1;
  }
  .min_img {
    width: 2.13rem;
    height: 2.13rem;
    border-radius: 8px;
    margin-right: 0.22rem;
  }
  .min_img_act {
    border: 2px solid #f43e62;
  }

  .partner-module {
    padding: 1.85rem 0 0 0;
  }

  .partner-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.81rem;
    color: #141414;
    line-height: 1.11rem;
  }

  .partner-title-ch {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.41rem;
    color: #000000;
    line-height: 0.56rem;

    margin: 0.44rem 0 0 0;
  }

  .company-image {
    width: 11.12rem;
    height: auto;
    margin: 1.48rem 0 0 0;
  }

  .contact-wrap {
    padding: 1.48rem 0.82rem;
    background: #c25e4d;
    margin: 1.85rem 0 1.85rem 0;
    display: none;
  }
  .contact-wrap_768 {
    padding: 1.48rem 0.82rem;
    background: #c25e4d;
    margin: 1.85rem 0 1.85rem 0;
    display: block;
  }
  .topInfo {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-bottom: 0.66rem;
	border-bottom: 0.02rem solid #FFFFFF;
  }
  .bigTxt {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.81rem;
    color: #ffffff;
    line-height: 0.59rem;
  }
  .contact_number {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.81rem;
    color: #ffffff;
    line-height: 0.59rem;
  }
  .contact-tips_768 {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.3rem;
    color: #ffffff;
    line-height: 0.3rem;
    text-align: right;
	padding-top: 0.54rem;
  }

  .contact-wrap div:nth-child(1) {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.72rem;
    color: #ffffff;
    line-height: 1.01rem;
  }
  .contact-wrap div:nth-child(2) {
    height: 0.02rem;
    background: #ffffff;
    margin: 0.58rem 0 0 0;
  }
  .contact-wrap div:nth-child(3) {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.72rem;
    color: #ffffff;
    line-height: 1.01rem;
    margin: 0.58rem 0 0 0;
  }
  .contact-wrap div:nth-child(4) {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.29rem;
    color: #ffffff;
    line-height: 0.29rem;
    margin: 0.22rem 0 0 0;
  }
}
//小web1440
@media screen and (min-width: 1440px) and (max-width: 1919px) {
	.mobile {
    display: none;
  }
  .top-bg {
    position: relative;
    width: 100%;
    height: 10.5rem;
    background-image: url("https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-top-bg.png");
    background-size: cover;
    background-position: center;
    padding: 3.57rem 0 0 0;
    box-sizing: border-box;
  }

  .top-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 1.19rem;
    color: #ffffff;
    line-height: 1.67rem;
  }

  .top-title-en {
    font-family: MADEEvolveSans;
    font-size: 0.41rem;
    color: #ffffff;
    line-height: 0.48rem;
    margin: 0.43rem 0 0 0;
  }

  .top-point-wrap {
    position: absolute;
    bottom: -1.98rem;
    left: 0;
    width: 100%;
    display: grid;
    justify-content: center;
    grid-template-columns: repeat(3, 7.22rem);
    gap: 0.62rem;
	box-sizing: border-box;
  }

  .top-point-item {
    position: relative;
    width:7.22rem;
	height: 3.96rem;
  }

  .top-point-item img {
    width: 100%;
    height: 3.96rem;
  }

  .point-info {
    position: absolute;
    bottom: 0.74rem;
    left: 1.22rem;
    text-align: left;
  }

  .point-info img {
    height: auto;
  }

  .point-info img:nth-child(1) {
    width: 0.67rem;
    margin: 0 0 0.46rem 0;
  }

  .point-info img:nth-child(2) {
    margin: 0 0 0.39rem 0;
    width: 0.78rem;
  }

  .point-info img:nth-child(3) {
    margin: 0 0 0.43rem 0;
    width: 0.63rem;
  }

  .point-info div {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.41rem;
    color: #ffffff;
    line-height: 0.56rem;
    margin: 0 0 0.19rem 0;
  }

  .point-info span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.3rem;
    color: #ffffff;
    line-height: 0.52rem;
  }

  .scene-module {
    padding: 4.74rem 0rem 1.72rem;
    display: flex;
    justify-content: center;
  }

  .scene-left {
    width: 7.89rem;
    min-width: 7.89rem;
    margin-right: 2.35rem;
    padding-top: 1.52rem;
  }

  .scene-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.93rem;
    color: #1a1a1a;
    line-height: 1.3rem;
    text-align: left;
    /* margin: 0.67rem 0 0 0; */
  }

  .scene-description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.41rem;
    color: #1a1a1a;
    line-height: 0.56rem;
    margin: 0.2rem 0 0 0;
    text-align: left;
  }

  .scene-items {
    margin: 1.17rem 0 0 0;
  }

  .scene-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0.02rem solid #bbbbbb;
    padding: 0 0 0.2rem 0;
    margin: 0 0 0.7rem 0;
  }

  .scene-item div {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.33rem;
    color: #1a1a1a;
  }

  .scene-item img {
    width: 0.43rem;
    height: auto;
  }

  .scene-right {
    width: 14.24rem;
    // height: 11.52rem;
    height: auto;
    margin-right: -2.0rem;
  }

  .content {
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    justify-content: center;
    margin: 2.2rem 0 0 0;
    /* padding: 0 4.83rem; */
    box-sizing: border-box;
  }
  .el-carousel__item h3 {
    color: #bbbbbb;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #f6f4f1;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #f6f4f1;
  }

  /deep/ .el-carousel__arrow {
    /* top: 16.42rem; */
    width: 1.2rem;
    height: 1.2rem;
    font-size: 0.5rem;
    z-index: 3;
  }

  /deep/.el-carousel__arrow i {
    font-size: 0.5rem;
  }

  /deep/.el-carousel__arrow--left {
    left: 20px;
  }

  /deep/.el-carousel__arrow--right {
    right: 20px;
  }

  .swiper-wrap {
    background: #1a1a1a;
  }

  .swiper-left {
    width: 9.35rem;
    text-align: left;
    margin-right: 2.8rem;
  }

  .swiper-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.93rem;
    color: #141414;
    line-height: 1.3rem;
  }

  .swiper-left-content {
    height: 4.96rem;
    width: 9.35rem;
    border-top: 0.02rem solid #000000;
    border-bottom: 0.02rem solid #000000;
    margin: 0.72rem 0 0 0;
    padding: 0.6rem 0 0 0;
    box-sizing: border-box;
  }

  .content-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .content-title-text {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.41rem;
    color: #141414;
    line-height: 0.44rem;
  }

  .content-title-num {
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 0.81rem;
    color: #141414;
    line-height: 1rem;
  }

  .content-description {
    width: 6.65rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.26rem;
    color: #141414;
    line-height: 0.52rem;
    margin: 0.32rem 0 0 0;
  }

  .content-tips {
    margin: 0.28rem 0 0 0;
  }

  .content-tips-item {
    display: flex;
    align-items: center;
    margin: 0 0 0.08rem 0;
  }

  .content-tips-item img {
    width: 0.28rem;
    height: auto;
  }

  .content-tips-item div {
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 0.22rem;
    color: #666666;
    line-height: 0.39rem;
    margin: 0 0 0 0.11rem;
  }

  .line-two {
    margin: 2.56rem 0 0 0;
  }

  .content-images {
    display: flex;
    align-items: center;
    margin: 1.78rem 0 0 0;
  }

  .content-images img {
    width: 2.12rem;
    height: auto;
    margin-right: 0.28rem;
  }

  .swiper-right {
    width: 10.74rem;
  }

  .partner-module {
    padding: 2.57rem 0 2.59rem;
  }

  .partner-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.81rem;
    color: #1a1a1a;
    line-height: 0.96rem;
  }

  .partner-title-ch {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.41rem;
    color: #333333;
    line-height: 0.56rem;
    margin: 0.15rem 0 0 0;
  }

  .company-image {
    width: 21.17rem;
    height: auto;
    margin: 1.85rem 0 0 0;
  }

  .contact-wrap {
    background: #c25e4d;
    padding: 1.5rem 1.9rem;
    margin: 2.6rem 0 0 0;
  }

  .contact-us {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .contact-us div {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.93rem;
    color: #ffffff;
	line-height: 0.59rem;
  }

  .contact-line {
    width: 100%;
    height: 0.02rem;
    background: #ffffff;
    margin: 0.76rem 0 0 0;
  }

  .contact-tips {
    width: 100%;
    text-align: right;

    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.37rem;
    color: #ffffff;
    line-height: 0.22rem;

    margin: 0.74rem 0 0 0;
  }
}
// 1920
@media screen and (min-width: 1920px) {
  .mobile {
    display: none;
  }
  .top-bg {
    position: relative;
    width: 100%;
    height: 10.05rem;
    background-image: url("https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution/solution-top-bg.png");
    background-size: cover;
    background-position: center;
    padding: 3.57rem 0 0 0;
    box-sizing: border-box;
  }

  .top-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 1.19rem;
    color: #ffffff;
    line-height: 1.67rem;
  }

  .top-title-en {
    font-family: MADEEvolveSans;
    font-size: 0.41rem;
    color: #ffffff;
    line-height: 0.48rem;
    margin: 0.43rem 0 0 0;
  }

  .top-point-wrap {
    position: absolute;
    bottom: -1.98rem;
    left: 0;
    width: 100%;
    display: grid;
    justify-content: center;
    grid-template-columns: repeat(3, 8.2rem);
    gap: 0.69rem;
  }

  .top-point-item {
    position: relative;
    width: 8.2rem;
  }

  .top-point-item img {
    width: 100%;
    height: auto;
  }

  .point-info {
    position: absolute;
    bottom: 0.74rem;
    left: 1.52rem;
    text-align: left;
  }

  .point-info img {
    height: auto;
  }

  .point-info img:nth-child(1) {
    width: 0.67rem;
    margin: 0 0 0.46rem 0;
  }

  .point-info img:nth-child(2) {
    margin: 0 0 0.39rem 0;
    width: 0.76rem;
  }

  .point-info img:nth-child(3) {
    margin: 0 0 0.43rem 0;
    width: 0.63rem;
  }

  .point-info div {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.41rem;
    color: #ffffff;
    line-height: 0.56rem;
    margin: 0 0 0.19rem 0;
  }

  .point-info span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.3rem;
    color: #ffffff;
    line-height: 0.52rem;
  }

  .scene-module {
    padding: 4.09rem 0rem 1.89rem;
    display: flex;
    justify-content: center;
  }

  .scene-left {
    width: 9.39rem;
    min-width: 9.39rem;
    margin-right: 2.07rem;
    padding-top: 1.52rem;
  }

  .scene-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.93rem;
    color: #1a1a1a;
    line-height: 1.3rem;
    text-align: left;
    /* margin: 0.67rem 0 0 0; */
  }

  .scene-description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.41rem;
    color: #1a1a1a;
    line-height: 0.56rem;
    margin: 0.2rem 0 0 0;
    text-align: left;
  }

  .scene-items {
    margin: 1.17rem 0 0 0;
  }

  .scene-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0.02rem solid #bbbbbb;
    padding: 0 0 0.2rem 0;
    margin: 0 0 0.7rem 0;
  }

  .scene-item div {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.33rem;
    color: #1a1a1a;
  }

  .scene-item img {
    width: 0.43rem;
    height: auto;
  }

  .scene-right {
    width: 17.54rem;
    height: 14.19rem;
    margin-right: -3.5rem;
  }

  .content {
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    justify-content: center;
    margin: 2.22rem 0 0 0;
    /* padding: 0 4.83rem; */
    box-sizing: border-box;
  }
  .el-carousel__item h3 {
    color: #bbbbbb;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #f6f4f1;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #f6f4f1;
  }

  /deep/ .el-carousel__arrow {
    /* top: 16.42rem; */
    width: 1.2rem;
    height: 1.2rem;
    font-size: 0.5rem;
    z-index: 3;
  }

  /deep/.el-carousel__arrow i {
    font-size: 0.5rem;
  }

  /deep/.el-carousel__arrow--left {
    left: 20px;
  }

  /deep/.el-carousel__arrow--right {
    right: 20px;
  }

  .swiper-wrap {
    background: #1a1a1a;
  }

  .swiper-left {
    width: 10.84rem;
    text-align: left;
    margin-right: 2.81rem;
  }

  .swiper-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.93rem;
    color: #141414;
    line-height: 1.3rem;
  }

  .swiper-left-content {
    height: 5.76rem;
    width: 10.84rem;
    border-top: 0.02rem solid #000000;
    border-bottom: 0.02rem solid #000000;
    margin: 0.83rem 0 0 0;
    padding: 0.46rem 0 0 0;
    box-sizing: border-box;
  }

  .content-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .content-title-text {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.41rem;
    color: #141414;
    line-height: 0.44rem;
  }

  .content-title-num {
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 0.81rem;
    color: #141414;
    line-height: 1rem;
  }

  .content-description {
    width: 6.65rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.26rem;
    color: #141414;
    line-height: 0.52rem;
    margin: 0.26rem 0 0 0;
  }

  .content-tips {
    margin: 0.5rem 0 0 0;
  }

  .content-tips-item {
    display: flex;
    align-items: center;
    margin: 0 0 0.08rem 0;
  }

  .content-tips-item img {
    width: 0.31rem;
    height: auto;
  }

  .content-tips-item div {
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 0.22rem;
    color: #666666;
    line-height: 0.44rem;
    margin: 0 0 0 0.17rem;
  }

  .line-two {
    margin: 2.56rem 0 0 0;
  }

  .content-images {
    display: flex;
    align-items: center;
    margin: 1.67rem 0 0 0;
  }

  .content-images img {
    width: 2.46rem;
    height: auto;
    margin-right: 0.33rem;
  }

  .swiper-right {
    width: 12.26rem;
  }

  .partner-module {
    padding: 2.94rem 0 2.22rem;
  }

  .partner-title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.81rem;
    color: #1a1a1a;
    line-height: 0.96rem;
  }

  .partner-title-ch {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.41rem;
    color: #333333;
    line-height: 0.56rem;
    margin: 0.15rem 0 0 0;
  }

  .company-image {
    width: 21.17rem;
    height: auto;
    margin: 1.85rem 0 0 0;
  }

  .contact-wrap {
    background: #c25e4d;
    padding: 1.5rem 4.81rem;
    margin: 2.96rem 0 0 0;
  }

  .contact-us {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .contact-us div {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.93rem;
    color: #ffffff;
  }

  .contact-line {
    width: 100%;
    height: 0.02rem;
    background: #ffffff;
    margin: 0.76rem 0 0 0;
  }

  .contact-tips {
    width: 100%;
    text-align: right;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.37rem;
    color: #ffffff;
    line-height: 0.22rem;
    margin: 0.74rem 0 0 0;
  }
}
</style>
